import React, { useEffect, useState } from "react";
import axios from "axios";

import {


  useNavigate,

  useParams,

} from "react-router-dom";

import {

  useDispatch,
  useSelector,

} from "react-redux";

import {

  createOrder,

} from "../../actions/orderActions";

import {

  useCart,

} from "../../components/CartContext";

import {

  useRestaurantSession,

} from "../../components/RestaurantSessionProvider";

import {

  isSessionExpiredError,

  getSessionExpiredMessage,

} from "../../utils/sessionErrorHandler";

import { fetchPriceSummary } from "../../actions/priceActions";

import "./css/OrderScreen.css";

function OrderScreen() {

  const navigate =

    useNavigate();

  const dispatch =

    useDispatch();

  const {

    restaurantId,

    tableId,

  } = useParams();

  /*

  =========================================================

  DINING SESSION

  =========================================================

  */

  const {

    sessionToken,

  } = useRestaurantSession();

  const {

    cart,

    clearCart,

  } = useCart();

  /* =========================================================

     PRICE SUMMARY FROM CHECKOUT

  ========================================================= */

  const { loading: priceLoading, summary: priceSummary, error: priceError } =
    useSelector((state) => state.price || {});

  const cartKey = JSON.stringify((cart || []).map((item) => [item.id, item.quantity]));
  const [pricePending, setPricePending] = useState(true);
  useEffect(() => {
    if (!cart || cart.length === 0) { setPricePending(false); return; }
    let active = true;
    setPricePending(true);
    const items = cart.map((item) => ({ menu_item_id: item.id, quantity: item.quantity }));
    Promise.resolve(dispatch(fetchPriceSummary(restaurantId, items)))
      .catch(() => {})
      .finally(() => { if (active) setPricePending(false); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, restaurantId, cartKey]);

  const priceReady = !pricePending && !priceLoading && !priceError &&
    priceSummary && priceSummary.total != null && Number.isFinite(Number(priceSummary.total));
  const subtotal = priceReady ? Number(priceSummary.subtotal || 0) : 0;
  const tax = priceReady ? Number(priceSummary.tax || 0) : 0;
  const serviceCharge = priceReady ? Number(priceSummary.service_charge || 0) : 0;
  const discount = priceReady ? Number(priceSummary.discount || 0) : 0;
  const total = priceReady ? Number(priceSummary.total) : 0;

  /* =========================================================

     STATE

  ========================================================= */

  const [

    paymentMethod,

    setPaymentMethod

  ] =

    useState("");

  const [

    notes,

    setNotes

  ] =

    useState("");

  const [

    loading,

    setLoading

  ] =

    useState(false);

  const [

    error,

    setError

  ] =

    useState("");

  const [paymentOptions, setPaymentOptions] = useState(null);
  useEffect(() => {
    let active = true;
    setPaymentOptions(null);
    setPaymentMethod("");
    axios.get(`/api/restaurants/${encodeURIComponent(restaurantId)}/payment-options/`)
      .then(({ data }) => {
        if (!active) return;
        setPaymentOptions(data);
        setPaymentMethod(data.allow_cash_payment ? "CASH" : data.allow_online_payment ? "ONLINE" : "");
      })
      .catch(() => {
        if (active) setPaymentOptions({ allow_cash_payment: false, allow_online_payment: false });
      });
    return () => { active = false; };
  }, [restaurantId]);
  const onlineAllowed = paymentOptions?.allow_online_payment === true;
  const cashAllowed = paymentOptions?.allow_cash_payment === true;

  /* =========================================================

     PATH

  ========================================================= */

  const homePath =

    `/${restaurantId}/table/${tableId}`;

  /* =========================================================

     BACK TO CHECKOUT

  ========================================================= */

  const handleBack = () => {

    navigate(

      `${homePath}/checkout`

    );

  };

  /* =========================================================

     PAYMENT METHOD

  ========================================================= */

  const handlePaymentMethod = (

    method

  ) => {

    if (!paymentOptions || (method === "ONLINE" && !onlineAllowed) || (method === "CASH" && !cashAllowed)) return;
    setPaymentMethod(method);

    setError("");

  };

  /* =========================================================

     CREATE ORDER

  ========================================================= */

  const handlePlaceOrder =

    async () => {

      /* -----------------------------------------------

         Validate payment method

      ----------------------------------------------- */

      if (!paymentOptions || (paymentMethod === "ONLINE" && !onlineAllowed) || (paymentMethod === "CASH" && !cashAllowed)) {
        setError("This payment method is not available for this restaurant.");
        return;
      }

      if (!paymentMethod) {

        setError(

          "Please select a payment method."

        );

        return;

      }

      /* -----------------------------------------------

         Validate cart

      ----------------------------------------------- */

      if (

        !cart ||

        cart.length === 0

      ) {

        setError(

          "Your cart is empty."

        );

        return;

      }

      /* -----------------------------------------------

         Validate dining session

      ----------------------------------------------- */

      if (!sessionToken) {

        setError(

          "Dining session is not ready. Please try again."

        );

        return;

      }

      try {

        setLoading(true);

        setError("");

        /* -----------------------------------------------

           COMMON ORDER PAYLOAD

        ----------------------------------------------- */

        const orderData = {

          items: cart.map(

            (item) => ({

              menu_item_id:

                item.id,

              quantity:

                item.quantity,

            })

          ),

          /*

          -----------------------------------------------

          DINING SESSION

          -----------------------------------------------

          */

          session_token:

            sessionToken,

          payment_method:

            paymentMethod,

          table_id:

            Number(tableId),

          notes:

            notes.trim(),

        };

        /* -----------------------------------------------

           COMMON REDUX ACTION

        ----------------------------------------------- */

        const response =

          await dispatch(

            createOrder(

              restaurantId,

              orderData

            )

          );

        /* -----------------------------------------------

           GET ORDER ID

        ----------------------------------------------- */

        const orderId =

          response?.order_id ||

          response?.id;
        const confirmedTotal = Number(response?.total ?? total);

        if (!orderId) {

          throw new Error(

            "Order was created but order ID was not returned."

          );

        }

        /* =================================================

           CASH

        ================================================= */

        if (

          paymentMethod === "CASH"

        ) {

          clearCart();

          navigate(

            `${homePath}/success`,

            {

              state: {

                orderId,

                paymentMethod:

                  "CASH",

                total:

                  confirmedTotal,

              },

            }

          );

          return;

        }

        /* =================================================

           ONLINE

        ================================================= */

        if (

          paymentMethod === "ONLINE"

        ) {

          navigate(

            `${homePath}/payment`,

            {

              state: {

                orderId,

                subtotal:

                  Number(subtotal),

                tax:

                  Number(tax),

                serviceCharge:

                  Number(serviceCharge),

                total:

                  confirmedTotal,

              },

            }

          );

        }

      } catch (err) {

        console.error(

          "Create order error:",

          err

        );

        /*

        =================================================

        DINING SESSION EXPIRED

        =================================================

        */

        if (

          isSessionExpiredError(err)

        ) {

          setError(

            "Your table session has ended. " +

            "Please scan the table QR code again " +

            "to start a new session."

          );

          return;

        }

        /*

        =================================================

        OTHER ERRORS

        =================================================

        */

        setError(

          getSessionExpiredMessage(err)

        );

      } finally {

        setLoading(false);

      }

    };

  /* =========================================================

     RENDER

  ========================================================= */

  return (

    <div className="t6-order-page">

      {/* =====================================================

          HERO

      ===================================================== */}

      <section className="t6-order-hero">

        <div className="t6-order-hero-inner">

          <button

            type="button"

            className="t6-order-back"

            onClick={handleBack}

          >

            ← Back to checkout

          </button>

          <span className="t6-order-eyebrow">

            YOUR ORDER

          </span>

          <h1>

            One last step

          </h1>

          <p>

            Choose how you'd like to pay and

            add any special requests for the kitchen.

          </p>

        </div>

      </section>

      {/* =====================================================

          MAIN

      ===================================================== */}

      <main className="t6-order-container">

        <div className="t6-order-layout">

          {/* =================================================

              LEFT

          ================================================= */}

          <section className="t6-order-details">

            {/* =================================================

                TABLE

            ================================================= */}

            <div className="t6-order-table-card">

              <div>

                <span>

                  TABLE

                </span>

                <strong>

                  {tableId}

                </strong>

              </div>

              <div className="t6-order-table-status">

                <span className="t6-status-dot">

                </span>

                Ready to order

              </div>

            </div>

            {/* =================================================

                NOTES

            ================================================= */}

            <div className="t6-order-section">

              <span className="t6-order-section-label">

                SPECIAL REQUESTS

              </span>

              <h2>

                Anything we should know?

              </h2>

              <p className="t6-order-section-description">

                Let our kitchen know about allergies,

                preferences, or special requests.

              </p>

              <textarea

                className="t6-order-notes"

                value={notes}

                onChange={(event) =>

                  setNotes(

                    event.target.value

                  )

                }

                placeholder="Example: No onions, please..."

                rows="5"

                maxLength="500"

              />

              <div className="t6-notes-count">

                {notes.length}/500

              </div>

            </div>

            {/* =================================================

                PAYMENT

            ================================================= */}

            <div className="t6-order-section">

              <span className="t6-order-section-label">

                PAYMENT

              </span>

              <h2>

                How would you like to pay?

              </h2>

              <p className="t6-order-section-description">

                Choose your preferred payment method.

              </p>

              <div className="t6-payment-options">

                {/* CASH */}

                <button

                  type="button"

                  disabled={!cashAllowed}
                  aria-disabled={!cashAllowed}
                  style={!cashAllowed ? { opacity: 0.45, cursor: "not-allowed" } : undefined}
                  className={`t6-payment-option ${

                    paymentMethod === "CASH"

                      ? "selected"

                      : ""

                  }`}

                  onClick={() =>

                    handlePaymentMethod(

                      "CASH"

                    )

                  }

                >

                  <span className="t6-payment-icon">

                    💵

                  </span>

                  <span className="t6-payment-content">

                    <strong>

                      CASH

                    </strong>

                    <small>

                      Pay with cash at the restaurant

                    </small>

                  </span>

                  <span className="t6-payment-radio">

                    {paymentMethod === "CASH"

                      ? "✓"

                      : ""}

                  </span>

                </button>

                {/* ONLINE */}

                <button

                  type="button"

                  disabled={!onlineAllowed}
                  aria-disabled={!onlineAllowed}
                  style={!onlineAllowed ? { opacity: 0.45, cursor: "not-allowed" } : undefined}
                  className={`t6-payment-option ${

                    paymentMethod === "ONLINE"

                      ? "selected"

                      : ""

                  }`}

                  onClick={() =>

                    handlePaymentMethod(

                      "ONLINE"

                    )

                  }

                >

                  <span className="t6-payment-icon">

                    💳

                  </span>

                  <span className="t6-payment-content">

                    <strong>

                      Pay online

                    </strong>

                    <small>

                      {onlineAllowed ? "Secure payment with Razorpay" : "Online payment unavailable"}

                    </small>

                  </span>

                  <span className="t6-payment-radio">

                    {paymentMethod === "ONLINE"

                      ? "✓"

                      : ""}

                  </span>

                </button>

              </div>

            </div>

            {/* =================================================

                ERROR

            ================================================= */}

            {(error || priceError) && (

              <div className="t6-order-error">

                {error || (typeof priceError === "string" ? priceError : "Unable to calculate price.")}

              </div>

            )}

          </section>

          {/* =================================================

              RIGHT - SUMMARY

          ================================================= */}

          <aside className="t6-order-summary">

            <span className="t6-order-summary-eyebrow">

              ORDER SUMMARY

            </span>

            <h2>

              Table {tableId}

            </h2>

            {/* SUBTOTAL */}

            <div className="t6-order-summary-line">

              <span>

                Subtotal

              </span>

              <strong>

                ₹

                {Number(

                  subtotal

                ).toFixed(2)}

              </strong>

            </div>

            {/* TAX */}

            <div className="t6-order-summary-line">

              <span>

                Tax

              </span>

              <strong>

                ₹

                {Number(

                  tax

                ).toFixed(2)}

              </strong>

            </div>

            {/* SERVICE */}

            <div className="t6-order-summary-line">

              <span>

                Service charge

              </span>

              <strong>

                ₹

                {Number(

                  serviceCharge

                ).toFixed(2)}

              </strong>

            </div>

            {discount > 0 && (
            <div className="t6-order-summary-line"><span>Discount</span><strong>-₹{discount.toFixed(2)}</strong></div>
          )}
          <div className="t6-order-summary-divider" />

            {/* TOTAL */}

            <div className="t6-order-total">

              <span>

                Total

              </span>

              <strong>

                ₹

                {Number(

                  total

                ).toFixed(2)}

              </strong>

            </div>

            {/* PLACE ORDER */}

            <button

              type="button"

              className="t6-place-order"

              onClick={

                handlePlaceOrder

              }

              disabled={loading || !sessionToken || !priceReady}

            >

              {loading

                ? "Creating order..."

                : "Place order"}

              {!loading && (

                <span>

                  →

                </span>

              )}

            </button>

            <p className="t6-order-summary-note">

              By placing this order, your request

              will be sent directly to the Kavos

              Taverna kitchen.

            </p>

          </aside>

        </div>

      </main>

    </div>

  );

}

export default OrderScreen;